/** @module Specification/PartMaterialSizeSpec/Matrix */
define([
	"dojo/_base/declare",
	"Specification/PartMaterialSize/Matrix",
	"../SizeVariationParams"
], function(declare, PartMaterialSizeVariationMatrix, {SIZE_SPEC_PARAMS}) {

	return declare(PartMaterialSizeVariationMatrix, {
		bAllowColumnFilter: false,
		id: SIZE_SPEC_PARAMS.attr,

		/**
		 * @override
		 * Add any dependency paths necessary to process matrix
		 */
		addDependencyPaths: function(h, paths) {
			paths.push("Child:CurrentRevision/Child:Items/Child:CommonSizeSpec");
			this.inherited(arguments);
		}
	});
});